import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LocaleService } from '../global-services/locale.service';

@Pipe({
    name: 'dynamicDate',
    pure: false, // Important: This makes the pipe update when locale changes
    standalone: true
})
export class DynamicDatePipe implements PipeTransform {
    constructor(private localeService: LocaleService) { } transform(
        value: Date | string | number | null | undefined,
        format?: string,
        timezone?: string,
        locale?: string
    ): string | null {
        if (!value) return null;

        const currentLocale = locale || this.localeService.getCurrentLocale();

        let actualFormat = format;
        if (format === "shortDate" || format === 'mediumDate' || format === 'longDate') {
            actualFormat = this.localeService.getDateFormat();
        }

        const datePipe = new DatePipe(currentLocale);

        return datePipe.transform(value, actualFormat, timezone, currentLocale);
    }
}